import React, { Component } from 'react'
import { connect } from 'react-redux'
import debounce from 'debounce'

import FacilityFilter from './AgencyFilter/IndexReactModal'
import FacilityGroupFilter from '../../FacilityGroup/Filter/Index'

import { fetchFacilities } from '../../../actions/facilitiesActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faSlidersH, faSpinner } from '@fortawesome/free-solid-svg-icons'

const connected = connect(store => {
  return {
    facilities: store.facilities.facilities,
    query: store.facilities.query,
    loading: store.facilities.fetching
  }
})
export class RequestFormStep1Facility extends Component {
  state = { search: this.props.query, filter: false, filterType: 'agency' }

  componentWillMount() {
    const { search } = this.state
    this.props.dispatch(fetchFacilities(search))
  }

  doFetchFacilities = debounce(() => {
    const { search } = this.state
    this.props.dispatch(fetchFacilities(search))
  }, 400)

  handleSearchChange = event => {
    this.setState({ search: event.target.value }, () => {
      this.doFetchFacilities()
    })
  }

  handleFilterToggle = () => {
    this.setState({ ...this.state, filter: !this.state.filter })
  }

  render() {
    const { loading } = this.props

    return (
      <div className="mb-12 ">
        <div className="text-xl font-bold">Campground or Facility to reserve at:</div>

        <div className="flex w-full lg:w-2/3">
          <div className="relative flex-grow">
            <input
              type="text"
              placeholder="Search..."
              onChange={this.handleSearchChange}
              defaultValue={this.state.search}
              className="w-full text-2xl p-2 border-l border-t border-b border-gray-300 rounded-l"
            />

            <div className="absolute right-0 top-0 mt-3 mr-4">
              <FontAwesomeIcon
                icon={loading ? faSpinner : faSearch}
                className={`text-3xl ${loading && 'animate-spin text-gray-300'}`}
              />
            </div>
          </div>
          <button
            onClick={this.handleFilterToggle}
            className="flex-none border rounded-r px-4 bg-gray-200 border-gray-300 text-gray-600"
          >
            <FontAwesomeIcon icon={faSlidersH} className="text-2xl transform rotate-90" />
            <span className="pl-2 text-xl hidden md:inline">Filter</span>
          </button>
        </div>

        {this.state.filterType !== 'agency' && (
          <FacilityGroupFilter open={this.state.filter} onClose={this.handleFilterToggle} />
        )}

        {this.state.filterType === 'agency' && (
          <FacilityFilter open={this.state.filter} onClose={this.handleFilterToggle} />
        )}
      </div>
    )
  }
}
export default connected(RequestFormStep1Facility)
